import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, unref as _unref, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "form-item-content" }
const _hoisted_3 = { class: "form-item-content" }
const _hoisted_4 = { class: "form-item-content" }
const _hoisted_5 = { class: "container" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 3 }
const _hoisted_8 = { key: 4 }
const _hoisted_9 = { key: 3 }

import { onMounted, reactive, ref } from "vue";
import { message } from "ant-design-vue";
import dayjs from "dayjs";
import { ColumnType } from "ant-design-vue/lib/table";
import { ToImage } from "@/utils/image";
import { Product } from "@/api/models/product/Product";
import { ProductOrderService } from "@/api/services/ProductOrderService";
import { ProductOrder } from "@/api/models/product_order/ProductOrder";
import { ProductOrderListRequest } from "@/api/models/product_order/ProductOrderListRequest";
import OrderDetail from "@/components/OrderDetail.vue";
import { Mail } from "@/api/models/mail/Mail";
import { MailService } from "@/api/services/MailService";
import { ReplyAddRequest } from "@/api/models/reply/ReplyAddRequest";
import { ReplyService } from "@/api/services/ReplyService";
import { ProductOrderUpdateRequest } from "@/api/models/product_order/ProductOrderUpdateRequest";
import { DeliveryRequest } from "@/api/models/config/DeliveryRequest";
import DeliveryView from "@/components/DeliveryView.vue";
import DeliveryPrint from "@/components/DeliveryPrint.vue";
import FileUpload from "@/components/FileUpload.vue";
import * as XLSX from "xlsx";


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderShipped',
  setup(__props) {

const vis = ref<boolean>(false);

const order = ref<ProductOrder>();

const handleView = (record: ProductOrder) => {
  vis.value = true;
  order.value = record;
};

dayjs.locale("zh-cn");

const total = ref<number>(0);
const splitMail1 = ref<string>("");
const splitMail2 = ref<string>("");
const splitMail3 = ref<string>("");
const splitMail4 = ref<string>("");
const splitMail5 = ref<string>("");

const listRequest = reactive<ProductOrderListRequest>({
  current: 1,
  size: 50,
  status: 4,
});

// @ts-ignore
const productList = ref<ProductOrder[]>([{}]);

const handleList = async () => {
  const res = await ProductOrderService.ListAll(listRequest);
  if (res.code === 0) {
    productList.value = res.data.records;
    total.value = res.data.total;
  } else {
    message.error(res.msg);
  }
};

const data = [
  [
    "收件人",
    "收件人地址",
    "寄件人",
    "寄件地址",
    "电话",
    "快递单号",
    "下单时间",
  ],
];

const xlsxExcel = async () => {
  // 创建工作簿并添加工作表
  for (let n = 0; n < productList.value.length; n++) {
    data.push([
      productList.value[n].recipient_name,
      productList.value[n].recipient_province +
        productList.value[n].recipient_city +
        productList.value[n].recipient_district +
        productList.value[n].recipient_address,
      productList.value[n].send_name,
      productList.value[n].send_province +
        productList.value[n].recipient_city +
        productList.value[n].send_district +
        productList.value[n].send_address,
      productList.value[n].send_phone,
      productList.value[n].delivery_number,
      dayjs(productList.value[n].create_at).format("YYYY-MM-DD HH:mm:ss"),
    ]);
  }

  const wb = XLSX.utils.book_new();
  // 创建工作表
  const ws = XLSX.utils.aoa_to_sheet(data);

  XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

  const currentTime = dayjs().format("YYYY-MM-DD HH:mm:ss");
  // 导出Excel文件
  XLSX.writeFile(wb, currentTime + "快递信息.xlsx");
};

const resetSearch = async () => {
  listRequest.current = 1;
  listRequest.size = 5;
  listRequest.category = undefined;
  await handleList();
};

onMounted(async () => {
  await handleList();
});

const handleSizeChange = (current: number, pageSize: number) => {
  listRequest.current = current;
  listRequest.size = pageSize;
  handleList();
};

const handleChange = (page: number, pageSize: number) => {
  listRequest.current = page;
  listRequest.size = pageSize;
  handleList();
};

const submitDelete = async (record: Product) => {
  const res = await ProductOrderService.Delete(record.id);
  if (res.code === 0) {
    message.success("删除成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const submitDrop = async (record: Product) => {
  const res = await ProductOrderService.Drop(record.id);
  if (res.code === 0) {
    message.success("删除成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const mailList = ref<Mail[]>([]);

const handleMailList = async () => {
  const res = await MailService.ListAll({ current: 0, size: 0 });
  if (res.code === 0) {
    mailList.value = res.data.records;
    total.value = res.data.total;
  } else {
    message.error(res.msg);
  }
};

const visReply = ref<boolean>(false);

const replyAddRequest = reactive<ReplyAddRequest>({
  status: 1,
  mail_method_id: 2,
});

const handleReply = async (record: ProductOrder) => {
  visReply.value = true;
  replyAddRequest.product_order_id = record.id;
};

const submitReply = async () => {
  if (splitMail1.value.length > 0) {
    replyAddRequest.delivery_number = splitMail1.value;
    const res = await ReplyService.Add(replyAddRequest);
    if (res.code === 0) {
      message.success("添加回信1成功");
      setTimeout(() => location.reload(), 1000);
    } else {
      message.error(res.msg);
    }
  }
  if (splitMail2.value.length > 0) {
    replyAddRequest.delivery_number = splitMail2.value;
    const res = await ReplyService.Add(replyAddRequest);
    if (res.code === 0) {
      message.success("添加回信2成功");
      setTimeout(() => location.reload(), 1000);
    } else {
      message.error(res.msg);
    }
  }
  if (splitMail3.value.length > 0) {
    replyAddRequest.delivery_number = splitMail3.value;
    const res = await ReplyService.Add(replyAddRequest);
    if (res.code === 0) {
      message.success("添加回信3成功");
      setTimeout(() => location.reload(), 1000);
    } else {
      message.error(res.msg);
    }
  }
  if (splitMail4.value.length > 0) {
    replyAddRequest.delivery_number = splitMail4.value;
    const res = await ReplyService.Add(replyAddRequest);
    if (res.code === 0) {
      message.success("添加回信4成功");
      setTimeout(() => location.reload(), 1000);
    } else {
      message.error(res.msg);
    }
  }
  if (splitMail5.value.length > 0) {
    replyAddRequest.delivery_number = splitMail5.value;
    const res = await ReplyService.Add(replyAddRequest);
    if (res.code === 0) {
      message.success("添加回信5成功");
      setTimeout(() => location.reload(), 1000);
    } else {
      message.error(res.msg);
    }
  }
};

const visOrderUpdate = ref<boolean>(false);

const orderUpdateRequest = reactive<ProductOrderUpdateRequest>({});

const handleOrderUpdate = (record: ProductOrder) => {
  visOrderUpdate.value = true;
  Object.assign(orderUpdateRequest, record);
};

const submitOrderUpdate = async () => {
  const res = await ProductOrderService.Update(orderUpdateRequest);
  if (res.code === 0) {
    message.success("修改信息成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const submitOrderUpdateStatus = async (record: ProductOrder) => {
  const res = await ProductOrderService.Update({ id: record.id, status: 5 });
  if (res.code === 0) {
    message.success("取消状态修改成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const visDelivery = ref<boolean>(false);

// @ts-ignore
const deliveryRequest = reactive<DeliveryRequest>({});

const handleDelivery = (record: ProductOrder) => {
  if (record.delivery_number === "") {
    message.error("快递单号不存在");
    return;
  }
  visDelivery.value = true;
  deliveryRequest.mail_method_name = record.mail_method_name;
  deliveryRequest.number = record.delivery_number;
};

const visPrint = ref<boolean>(false);

// @ts-ignore
const accept = reactive<ProductOrder>({});

const handlePrint = (record: ProductOrder) => {
  visPrint.value = true;
  Object.assign(accept, record);
};

const columns: ColumnType[] = [
  {
    title: "Id",
    dataIndex: "id",
    align: "center",
    width: 100,
  },
  {
    title: "订单号",
    dataIndex: "order_id",
    align: "center",
  },
  {
    title: "下单时间",
    dataIndex: "create_at",
    align: "center",
  },
  // {
  //   title: "会员",
  //   dataIndex: "user_open_id",
  //   align: "center",
  // },
  // {
  //   title: "邮寄方式",
  //   dataIndex: "mail_method_name",
  //   align: "center",
  // },
  {
    title: "总费用",
    dataIndex: "total_price",
    align: "center",
  },
  {
    title: "快递单号",
    dataIndex: "delivery_number",
    align: "center",
  },
  {
    title: "上传照片",
    dataIndex: "image_url",
    align: "center",
  },
  // {
  //   title: "订单类别",
  //   dataIndex: "category",
  //   align: "center",
  // },
  // {
  //   title: "提交方式",
  //   dataIndex: "write_category",
  //   align: "center",
  // },
  {
    title: "发件人信息",
    dataIndex: "send_name",
    align: "center",
  },
  // {
  //   title: "发件人电话号码",
  //   dataIndex: "send_phone",
  //   align: "center",
  // },
  {
    title: "收件人信息",
    dataIndex: "recipient_name",
    align: "center",
  },
  // {
  //   title: "收件人电话号码",
  //   dataIndex: "recipient_phone",
  //   align: "center",
  // },
  // {
  //   title: "支付方式",
  //   dataIndex: "pay_method",
  //   align: "center",
  // },
  // {
  //   title: "平台来源",
  //   dataIndex: "platform",
  //   align: "center",
  // },
  // {
  //   title: "修改时间",
  //   dataIndex: "update_at",
  //   align: "center",
  // },
  {
    title: "操作",
    dataIndex: "operator",
    align: "center",
    width: 300,
  },
];

onMounted(() => {
  handleMailList();
});

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_textarea = _resolveComponent("a-textarea")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_form, {
        model: handleList,
        class: "search-form",
        onSubmit: handleList
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, { name: "content" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _cache[22] || (_cache[22] = _createElementVNode("div", { class: "label" }, "搜索内容：", -1)),
                _createVNode(_component_a_input, {
                  placeholder: "商品描述/订单详细",
                  value: listRequest.content,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((listRequest.content) = $event))
                }, null, 8, ["value"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, { name: "content" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _cache[23] || (_cache[23] = _createElementVNode("div", { class: "label" }, "用户ID：", -1)),
                _createVNode(_component_a_input, {
                  placeholder: "商品描述/订单详细",
                  value: listRequest.user_id,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((listRequest.user_id) = $event))
                }, null, 8, ["value"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _cache[27] || (_cache[27] = _createElementVNode("div", { class: "label" }, "下单类型：", -1)),
                _createVNode(_component_a_select, {
                  style: {"width":"200px"},
                  value: listRequest.category,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((listRequest.category) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: 1 }, {
                      default: _withCtx(() => _cache[24] || (_cache[24] = [
                        _createTextVNode("商品订单")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: 2 }, {
                      default: _withCtx(() => _cache[25] || (_cache[25] = [
                        _createTextVNode("信件订单")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: 3 }, {
                      default: _withCtx(() => _cache[26] || (_cache[26] = [
                        _createTextVNode("明信片")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "primary",
                "html-type": "submit"
              }, {
                default: _withCtx(() => _cache[28] || (_cache[28] = [
                  _createTextVNode("搜索")
                ])),
                _: 1
              }),
              _createVNode(_component_a_button, {
                style: {"margin-left":"10px"},
                onClick: resetSearch
              }, {
                default: _withCtx(() => _cache[29] || (_cache[29] = [
                  _createTextVNode("重置")
                ])),
                _: 1
              }),
              _createVNode(_component_a_button, {
                style: {"margin-left":"10px"},
                onClick: xlsxExcel
              }, {
                default: _withCtx(() => _cache[30] || (_cache[30] = [
                  _createTextVNode("导出")
                ])),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_a_table, {
        columns: columns,
        "data-source": productList.value,
        pagination: {
        current: listRequest.current,
        pageSize: listRequest.size,
        total: total.value,
        defaultPageSize: listRequest.size,
        showSizeChanger: true,
        pageSizeOptions: [10, 20, 30, 40, 50],
        onChange: handleChange,
        onShowSizeChange: handleSizeChange,
      },
        bordered: "",
        scroll: { x: 1000, y: 600 },
        style: {"min-width":"600px"}
      }, {
        bodyCell: _withCtx(({ column, record }) => [
          (column.dataIndex === 'is_delete')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (record.is_delete === 1)
                  ? (_openBlock(), _createBlock(_component_a_tag, {
                      key: 0,
                      color: "green"
                    }, {
                      default: _withCtx(() => _cache[31] || (_cache[31] = [
                        _createTextVNode("正常")
                      ])),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (record.is_delete === 2)
                  ? (_openBlock(), _createBlock(_component_a_tag, {
                      key: 1,
                      color: "red"
                    }, {
                      default: _withCtx(() => _cache[32] || (_cache[32] = [
                        _createTextVNode("回收站")
                      ])),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ], 64))
            : (column.dataIndex === 'status')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (record.status === 1)
                    ? (_openBlock(), _createBlock(_component_a_tag, {
                        key: 0,
                        color: "green"
                      }, {
                        default: _withCtx(() => _cache[33] || (_cache[33] = [
                          _createTextVNode("可用")
                        ])),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (record.status === 2)
                    ? (_openBlock(), _createBlock(_component_a_tag, {
                        key: 1,
                        color: "red"
                      }, {
                        default: _withCtx(() => _cache[34] || (_cache[34] = [
                          _createTextVNode("禁用")
                        ])),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ], 64))
              : (column.dataIndex === 'image_url')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    (record.image_url !== undefined && record.image_url !== null)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.image_url.slice(0, 2), (i) => {
                            return (_openBlock(), _createBlock(_component_a_image, {
                              key: i,
                              src: _unref(ToImage)(i),
                              style: {"height":"60px","width":"auto","margin-top":"5px"}
                            }, null, 8, ["src"]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                : (column.dataIndex === 'create_at')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(dayjs)(record.create_at).format("YYYY-MM-DD HH:mm:ss")), 1))
                  : (column.dataIndex === 'update_at')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_unref(dayjs)(record.update_at).format("YYYY-MM-DD HH:mm:ss")), 1))
                    : (column.dataIndex === 'operator')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                          _createVNode(_component_a_button, {
                            onClick: ($event: any) => (handleView(record)),
                            type: "primary",
                            size: "small",
                            style: { marginRight: '8px' }
                          }, {
                            default: _withCtx(() => _cache[35] || (_cache[35] = [
                              _createTextVNode("查看 ")
                            ])),
                            _: 2
                          }, 1032, ["onClick"]),
                          _createVNode(_component_a_button, {
                            onClick: ($event: any) => (handleReply(record)),
                            type: "primary",
                            size: "small",
                            style: {
              backgroundColor: '#74eeb9',
              color: 'white',
              marginRight: '8px',
            }
                          }, {
                            default: _withCtx(() => _cache[36] || (_cache[36] = [
                              _createTextVNode("回信 ")
                            ])),
                            _: 2
                          }, 1032, ["onClick"]),
                          _createVNode(_component_a_button, {
                            onClick: ($event: any) => (handleDelivery(record)),
                            type: "primary",
                            size: "small",
                            style: {
              backgroundColor: '#ee74cb',
              color: 'white',
              marginRight: '8px',
            }
                          }, {
                            default: _withCtx(() => _cache[37] || (_cache[37] = [
                              _createTextVNode("查看物流信息 ")
                            ])),
                            _: 2
                          }, 1032, ["onClick"]),
                          _createVNode(_component_a_button, {
                            onClick: ($event: any) => (submitOrderUpdateStatus(record)),
                            type: "primary",
                            size: "small",
                            style: {
              backgroundColor: '#d074ee',
              color: 'white',
              marginRight: '8px',
              marginTop: '4px',
            }
                          }, {
                            default: _withCtx(() => _cache[38] || (_cache[38] = [
                              _createTextVNode("取消 ")
                            ])),
                            _: 2
                          }, 1032, ["onClick"]),
                          _createVNode(_component_a_button, {
                            onClick: ($event: any) => (handlePrint(record)),
                            type: "primary",
                            size: "small",
                            style: {
              backgroundColor: '#74bbee',
              color: 'white',
              marginRight: '8px',
            }
                          }, {
                            default: _withCtx(() => _cache[39] || (_cache[39] = [
                              _createTextVNode("打印地址 ")
                            ])),
                            _: 2
                          }, 1032, ["onClick"]),
                          _createVNode(_component_a_button, {
                            onClick: ($event: any) => (handleOrderUpdate(record)),
                            type: "primary",
                            size: "small",
                            style: {
              backgroundColor: '#7476ee',
              color: 'white',
              marginRight: '8px',
              marginTop: '4px',
            }
                          }, {
                            default: _withCtx(() => _cache[40] || (_cache[40] = [
                              _createTextVNode("修改内容 ")
                            ])),
                            _: 2
                          }, 1032, ["onClick"])
                        ], 64))
                      : (column.dataIndex === 'category')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                            (record.category === 1)
                              ? (_openBlock(), _createBlock(_component_a_tag, {
                                  key: 0,
                                  color: "green"
                                }, {
                                  default: _withCtx(() => _cache[41] || (_cache[41] = [
                                    _createTextVNode("商品订单")
                                  ])),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (record.category === 2)
                              ? (_openBlock(), _createBlock(_component_a_tag, {
                                  key: 1,
                                  color: "blue"
                                }, {
                                  default: _withCtx(() => _cache[42] || (_cache[42] = [
                                    _createTextVNode("信件订单")
                                  ])),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (record.category === 3)
                              ? (_openBlock(), _createBlock(_component_a_tag, {
                                  key: 2,
                                  color: "yellow"
                                }, {
                                  default: _withCtx(() => _cache[43] || (_cache[43] = [
                                    _createTextVNode("明信片")
                                  ])),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ], 64))
                        : (column.dataIndex === 'write_category')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                              (record.write_category === 1)
                                ? (_openBlock(), _createBlock(_component_a_tag, {
                                    key: 0,
                                    color: "green"
                                  }, {
                                    default: _withCtx(() => _cache[44] || (_cache[44] = [
                                      _createTextVNode("在线填写 ")
                                    ])),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (record.write_category === 2)
                                ? (_openBlock(), _createBlock(_component_a_tag, {
                                    key: 1,
                                    color: "blue"
                                  }, {
                                    default: _withCtx(() => _cache[45] || (_cache[45] = [
                                      _createTextVNode("手写拍照 ")
                                    ])),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (record.write_category === 3)
                                ? (_openBlock(), _createBlock(_component_a_tag, {
                                    key: 2,
                                    color: "yellow"
                                  }, {
                                    default: _withCtx(() => _cache[46] || (_cache[46] = [
                                      _createTextVNode("钢笔代写 ")
                                    ])),
                                    _: 1
                                  }))
                                : (_openBlock(), _createElementBlock("span", _hoisted_9))
                            ], 64))
                          : (column.dataIndex === 'send_name')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                                _createElementVNode("div", null, _toDisplayString(record.send_name), 1),
                                _createElementVNode("div", null, _toDisplayString(record.send_province) + " " + _toDisplayString(record.send_city) + " " + _toDisplayString(record.send_district), 1),
                                _createElementVNode("div", null, _toDisplayString(record.send_address), 1)
                              ], 64))
                            : (column.dataIndex === 'recipient_name')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 9 }, [
                                  _createElementVNode("div", null, _toDisplayString(record.recipient_name), 1),
                                  _createElementVNode("div", null, _toDisplayString(record.recipient_province) + " " + _toDisplayString(record.recipient_city) + " " + _toDisplayString(record.recipient_district), 1),
                                  _createElementVNode("div", null, _toDisplayString(record.recipient_address), 1)
                                ], 64))
                              : (column.dataIndex === 'pay_method')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 10 }, [
                                    (record.pay_method === 1)
                                      ? (_openBlock(), _createBlock(_component_a_tag, {
                                          key: 0,
                                          color: "yellow"
                                        }, {
                                          default: _withCtx(() => _cache[47] || (_cache[47] = [
                                            _createTextVNode("余额支付")
                                          ])),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true),
                                    (record.pay_method === 2)
                                      ? (_openBlock(), _createBlock(_component_a_tag, {
                                          key: 1,
                                          color: "green"
                                        }, {
                                          default: _withCtx(() => _cache[48] || (_cache[48] = [
                                            _createTextVNode("微信支付")
                                          ])),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                : (column.dataIndex === 'platform')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 11 }, [
                                      (record.platform === 1)
                                        ? (_openBlock(), _createBlock(_component_a_tag, {
                                            key: 0,
                                            color: "green"
                                          }, {
                                            default: _withCtx(() => _cache[49] || (_cache[49] = [
                                              _createTextVNode("微信小程序")
                                            ])),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true)
                                    ], 64))
                                  : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["data-source", "pagination"])
    ]),
    _createVNode(_component_a_modal, {
      open: vis.value,
      "onUpdate:open": _cache[3] || (_cache[3] = ($event: any) => ((vis).value = $event)),
      closable: false,
      footer: null,
      width: "1400px",
      title: "订单详情"
    }, {
      default: _withCtx(() => [
        _createVNode(OrderDetail, { order: order.value }, null, 8, ["order"])
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(_component_a_modal, {
      open: visDelivery.value,
      "onUpdate:open": _cache[4] || (_cache[4] = ($event: any) => ((visDelivery).value = $event)),
      closable: false,
      footer: null,
      width: "1400px",
      title: "物流信息"
    }, {
      default: _withCtx(() => [
        _createVNode(DeliveryView, { accept: deliveryRequest }, null, 8, ["accept"])
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(_component_a_modal, {
      open: visPrint.value,
      "onUpdate:open": _cache[5] || (_cache[5] = ($event: any) => ((visPrint).value = $event)),
      closable: false,
      footer: null,
      width: "800px",
      title: "打印信息"
    }, {
      default: _withCtx(() => [
        _createVNode(DeliveryPrint, { accept: accept }, null, 8, ["accept"])
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(_component_a_modal, {
      open: visReply.value,
      "onUpdate:open": _cache[14] || (_cache[14] = ($event: any) => ((visReply).value = $event)),
      title: "创建回信",
      onOk: submitReply,
      cancelText: "取消"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, { model: replyAddRequest }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "快递单号" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: splitMail1.value,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((splitMail1).value = $event))
                }, null, 8, ["value"]),
                _createVNode(_component_a_input, {
                  value: splitMail2.value,
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((splitMail2).value = $event))
                }, null, 8, ["value"]),
                _createVNode(_component_a_input, {
                  value: splitMail3.value,
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((splitMail3).value = $event))
                }, null, 8, ["value"]),
                _createVNode(_component_a_input, {
                  value: splitMail4.value,
                  "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((splitMail4).value = $event))
                }, null, 8, ["value"]),
                _createVNode(_component_a_input, {
                  value: splitMail5.value,
                  "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((splitMail5).value = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "回信状态" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: replyAddRequest.status,
                  "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((replyAddRequest.status) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: 1 }, {
                      default: _withCtx(() => _cache[50] || (_cache[50] = [
                        _createTextVNode("待寄出")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: 2 }, {
                      default: _withCtx(() => _cache[51] || (_cache[51] = [
                        _createTextVNode("运输中")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: 3 }, {
                      default: _withCtx(() => _cache[52] || (_cache[52] = [
                        _createTextVNode("已完成")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "运输方式" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: replyAddRequest.mail_method_id,
                  "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((replyAddRequest.mail_method_id) = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mailList.value, (mail) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        value: mail.id,
                        key: mail.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(mail.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "内容" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_textarea, {
                  value: replyAddRequest.content,
                  "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((replyAddRequest.content) = $event)),
                  rows: 4
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(_component_a_modal, {
      open: visOrderUpdate.value,
      "onUpdate:open": _cache[21] || (_cache[21] = ($event: any) => ((visOrderUpdate).value = $event)),
      title: "修改订单信息",
      onOk: submitOrderUpdate,
      cancelText: "取消"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, { model: orderUpdateRequest }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "快递单号" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: orderUpdateRequest.delivery_number,
                  "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((orderUpdateRequest.delivery_number) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "信件标题" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: orderUpdateRequest.title,
                  "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((orderUpdateRequest.title) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "信件作者" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: orderUpdateRequest.author,
                  "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((orderUpdateRequest.author) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "信件时间" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: orderUpdateRequest.write_date,
                  "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((orderUpdateRequest.write_date) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "内容" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_textarea, {
                  value: orderUpdateRequest.content,
                  "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((orderUpdateRequest.content) = $event)),
                  rows: 4
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "制作效果图" }, {
              default: _withCtx(() => [
                _createVNode(FileUpload, {
                  modelValue: orderUpdateRequest.avatar,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((orderUpdateRequest.avatar) = $event)),
                  style: {"display":"block"}
                }, null, 8, ["modelValue"]),
                (orderUpdateRequest.avatar !== '')
                  ? (_openBlock(), _createBlock(_component_a_image, {
                      key: 0,
                      src: _unref(ToImage)(orderUpdateRequest.avatar),
                      style: {"max-height":"150px","display":"block","margin-top":"10px"}
                    }, null, 8, ["src"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["open"])
  ], 64))
}
}

})